<template>
  <div class="request-approval-container">
    <Email v-show="$store.state.modalStore.showNewVendorEmail" />
    <!-- <Loading v-if="$store.state.globalLoading" /> -->
    <div class="request-approval-dialog">
      <div class="request-approval-content">
        <div class="request-approval-body">
          <div class="req-app-full-container">
            <div class="req-app-full-tittle">TIKET VENDOR BARU</div>
            <div class="req-app-full-wrapper" v-if="dataUpdate">
              <div class="req-app-half-container">
                <div class="half-input-wrapper">
                  <div class="hiw-label">Request ID</div>
                  <input type="text" class="hiw-text" placeholder="Otomatis dari Sistem" :value="code" disabled />
                </div>
                <div class="half-input-wrapper">
                  <div class="hiw-label">
                    Deskripsi <span class="text-ast">*</span>
                  </div>
                  <input type="text" class="hiw-text" v-model="desc" disabled />
                </div>
                <div class="half-input-wrapper">
                  <div class="hiw-label">
                    Nama Pengadaan <span class="text-ast">*</span>
                  </div>
                  <input type="text" class="hiw-text" v-model="nama_pengadaan" disabled />
                </div>
                <div class="half-input-wrapper">
                  <div class="hiw-label">Kategori</div>
                  <select v-model="kategori_id" class="hiw-text">
                    <option v-for="(option, index) in kategoryList" :key="index" :value="option.id" disabled>
                      {{ option.name }}
                    </option>
                  </select>
                </div>
                <div class="half-input-wrapper">
                  <div class="hiw-label">
                    Nama Vendor <span class="text-ast">*</span>
                  </div>
                  <input type="text" class="hiw-text" v-model="nama_vendor" disabled />
                </div>
                <div class="half-input-wrapper">
                  <div class="hiw-label">
                    PIC Vendor <span class="text-ast">*</span>
                  </div>
                  <input type="text" class="hiw-text" v-model="pic_vendor" disabled />
                </div>
                <div class="half-input-wrapper">
                  <div class="hiw-label">
                    No. Telepon PIC <span class="text-ast">*</span>
                  </div>
                  <input type="text" class="hiw-text" v-model="no_telepon" disabled />
                </div>
                <div class="half-input-wrapper">
                  <div class="hiw-label">
                    Email Vendor <span class="text-ast">*</span>
                  </div>
                  <input type="email" class="hiw-text" v-model="email_vendor" disabled />
                </div>
                <div class="half-input-wrapper">
                  <div class="hiw-label">Priority</div>
                  <select v-model="priority" class="hiw-text">
                    <option v-for="(option, index) in priorityList" :key="index" :value="option.id" disabled>
                      {{ option.desc }}
                    </option>
                  </select>
                </div>
                <div class="half-input-wrapper">
                  <div class="hiw-label" style="cursor: pointer">
                    Dokumen Petunjuk
                  </div>
                  <label class="btn btn-default btn-file" style="width:100%; text-align:left">
                    <i class="fas fa-download" @click="downloadDoc()"></i>
                  </label>
                </div>
              </div>
              <div class="req-app-half-container">
                <!-- <div class="half-input-wrapper">
                    <div class="hiw-label">Due By</div>
                    <div class="hiw-multiple">
                      <input class="hiw-2-row" type="date">
                      <input class="hiw-2-row" type="date">
                    </div>
                  </div> -->
                <div class="half-input-wrapper">
                  <div class="hiw-label">Bidang Usaha</div>
                  <div class="hiw-multiple">
                    <label class="hiw-2-row"><input type="radio" value="1" v-model="bidang_usaha_id" disabled
                        style="margin-right: 10px" />Badan Usaha</label>
                    <label class="hiw-2-row"><input type="radio" value="2" v-model="bidang_usaha_id" disabled
                        style="margin-right: 10px" />Perorangan</label>
                  </div>
                </div>
                <div class="half-input-wrapper">
                  <div class="hiw-label">
                    Registrasi ke Sistem <span class="text-ast">*</span>
                  </div>
                  <div class="hiw-multiple">
                    <label class="hiw-4-row"><input type="checkbox" v-model="register_ariba" value="1"
                        style="margin-right: 10px" disabled />ARIBA</label>
                    <label class="hiw-4-row"><input type="checkbox" v-model="register_gems" value="1" disabled
                        style="margin-right: 10px" />SAP GEMS</label>
                    <label class="hiw-4-row"><input type="checkbox" v-model="register_bce" value="1" disabled
                        style="margin-right: 10px" />BCE</label>
                    <label class="hiw-4-row"><input type="checkbox" v-model="register_bkes" value="1" disabled
                        style="margin-right: 10px" />BKES</label>
                  </div>
                </div>
                <div class="half-input-wrapper">
                  <div class="hiw-label">Tipe Pendaftaran Vendor</div>
                  <div class="hiw-multiple">
                    <label class="hiw-4-row popup"><input type="radio" value="1" v-model="type_pendaftaran_id"
                        style="margin-right: 10px" disabled />Nasional
                      <span class="popuptext">PT, PT TBK, YAYASAN, CV, BUMDES, KOPERASI,
                        PERKUMPULAN</span></label>
                    <label class="hiw-4-row popup"><input type="radio" value="2" v-model="type_pendaftaran_id"
                        style="margin-right: 10px" disabled />Internasional
                      <span class="popuptext">
                        PTE LTD, LTD, PTE, CORP, INC</span></label>
                    <label class="hiw-4-row popup"><input type="radio" value="3" v-model="type_pendaftaran_id"
                        style="margin-right: 10px" disabled />Khusus
                      <span class="popuptext">Instansi Pemerintah, Bank, Rumah Sakit, Hotel, Sekolah,
                        Demurage, E-commerce</span></label>
                    <label class="hiw-4-row popup"><input type="radio" value="4" v-model="type_pendaftaran_id"
                        style="margin-right: 10px" disabled />Internal Memo
                      <span class="popuptext">
                        Dokumen tdk ada/lengkap, Produsen, Pabrikan, HAKI,
                        Emergency, Direksi appointment</span>
                      <i class="fas fa-upload"></i>
                    </label>
                    <input type="file" class="hiw-text" v-show="type_pendaftaran_id == '4'" />
                  </div>
                </div>
                <div class="half-input-wrapper">
                  <div class="hiw-label">Penilaian</div>
                  <div class="hiw-multiple">
                    <label class="hiw-2-row"><input type="checkbox" v-model="assesment_k3l" value="k3l"
                        style="margin-right: 10px" disabled />K3L</label>
                    <label class="hiw-2-row"><input type="checkbox" v-model="assesment_kplh" value="kplh"
                        style="margin-right: 10px" disabled />KPLH</label>
                  </div>
                </div>
                <div class="half-input-wrapper">
                  <div class="hiw-label">Dokumen Legalitas</div>
                  <!-- <input type="file" class="hiw-text"> -->
                  <label class="btn btn-default btn-file">
                    <i class="fas fa-upload"></i> {{ theFileName }}
                    <input type="file" style="display: none;" @change="fileChangeHandler" disabled />
                  </label>
                </div>
                <div class="half-input-wrapper">
                  <div class="hiw-label">Note</div>
                  <textarea class="hiw-area" v-model="note" disabled />
                </div>
              </div>
            </div>
            <div class="req-app-full-btn-wrapper" v-if="firstRoute($route.path) != 'myrequest'">
              <div class="req-app-btn-submit mr10" @click="approve()"
                v-if="$route.params.status != 9 && $route.params.status != 10">
                Approve
              </div>
              <div class="req-app-btn-submit mr10" @click="approveHead()" v-if="
                $route.params.status == 9 ||
                ($route.params.status == 10 &&
                  $get($store, 'state.role_id') == 2)
              ">
                Approve Head
              </div>
              <div class="req-app-btn-submit mr10" @click="reject()"
                v-if="$route.params.status != 9 && $route.params.status != 10">
                Reject
              </div>
              <div class="req-app-btn-submit mr10" @click="reviseNow()" v-if="
                $route.params.status != 6 &&
                $route.params.status != 9 &&
                $route.params.status != 10
              ">
                Revise Now
              </div>
              <div class="req-app-btn-submit mr10" @click="needReview()"
                v-if="$route.params.status != 9 && $route.params.status != 10">
                Need Review
              </div>
              <div class="req-app-btn-submit mr10" @click="reviewHead()" v-if="
                $route.params.status == 9 ||
                ($route.params.status == 10 &&
                  $get($store, 'state.role_id') == 2)
              ">
                Review Head
              </div>
              <div class="req-app-btn-submit mr10" @click="postpone()"
                v-if="$route.params.status != 9 && $route.params.status != 10">
                Postpone
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { api } from '../../services/config'
export default {
  components: {
    Email: () => import('@/components/modal/newVendorEmail.vue'),
  },
  data() {
    return {
      chooseBu: '',
      chooseTypeRegister: '',
      chooseAssesment: [],
      chooseServer: [],
      files: [],

      priorityList: [
        {
          id: 1,
          desc: 'Very High',
        },
        {
          id: 2,
          desc: 'High',
        },
        {
          id: 3,
          desc: 'Medium',
        },
        {
          id: 4,
          desc: 'Low',
        },
        {
          id: 5,
          desc: 'Very Low',
        },
      ],
      kategoryList: [
        {
          id: 1,
          desc: 'CAT - CATEGORY 1',
        },
        {
          id: 2,
          desc: 'GIL - GA,IT & LONG TAILS',
        },
        {
          id: 3,
          desc: 'FEL - FUEL, LUBRICANT & ENERGY',
        },
        {
          id: 4,
          desc: 'MRR - MAINTENANCE & REPAIR, RENTAL',
        },
        {
          id: 5,
          desc: 'CPI - COAL PROCESSING & INFRASTRUCTURE PROJECT',
        },
      ],

      code: '',
      desc: '',
      nama_pengadaan: '',
      kategori_id: 1,
      nama_vendor: '',
      pic_vendor: '',
      no_telepon: '',
      email_vendor: '',
      priority: 5,

      //due_date:,
      bidang_usaha_id: 1,
      type_pendaftaran_id: 1,
      register_ariba: true,
      register_gems: false,
      register_bce: false,
      register_bkes: false,
      assesment_k3l: false,
      assesment_kplh: false,
      note: '',
    }
  },
  async created() {
    await this.getVendorCategory()
    await this.$store.dispatch('myRequest/requestDetail', this.$route.params.id)
  },
  computed: {
    theFileName() {
      if (this.files.length > 0 && 'name' in this.files[0]) {
        return this.files[0].name
      }
      return this.labelPlaceholder
    },
    dataUpdate() {
      this.code = this.$get(this.$store, 'state.myRequest.detail.code', '')
      this.desc = this.$get(this.$store, 'state.myRequest.detail.desc', '')
      this.nama_pengadaan = this.$get(
        this.$store,
        'state.myRequest.detail.nama_pengadaan',
        ''
      )
      this.kategori_id = this.$get(
        this.$store,
        'state.myRequest.detail.kategori_id',
        1
      )
      this.nama_vendor = this.$get(
        this.$store,
        'state.myRequest.detail.nama_vendor'
      )
      this.pic_vendor = this.$get(
        this.$store,
        'state.myRequest.detail.pic_vendor'
      )
      this.no_telepon = this.$get(
        this.$store,
        'state.myRequest.detail.no_telepon'
      )
      this.email_vendor = this.$get(
        this.$store,
        'state.myRequest.detail.email_vendor'
      )
      this.priority = this.$get(
        this.$store,
        'state.myRequest.detail.priority',
        5
      )
      this.bidang_usaha_id = this.$get(
        this.$store,
        'state.myRequest.detail.bidang_usaha_id',
        1
      )
      this.type_pendaftaran_id = this.$get(
        this.$store,
        'state.myRequest.detail.type_pendaftaran_id',
        1
      )
      this.register_ariba = true
      this.register_gems = this.$get(
        this.$store,
        'state.myRequest.detail.register_gems',
        false
      )
      this.register_bce = this.$get(
        this.$store,
        'state.myRequest.detail.register_bce',
        false
      )
      this.register_bkes = this.$get(
        this.$store,
        'state.myRequest.detail.register_bkes',
        false
      )
      this.assesment_k3l = this.$get(
        this.$store,
        'state.myRequest.detail.assesment_k3l',
        false
      )
      this.assesment_kplh = this.$get(
        this.$store,
        'state.myRequest.detail.assesment_kplh',
        false
      )
      this.note = this.$get(this.$store, 'state.myRequest.detail.note', '')

      return true
    },
  },
  methods: {
    async getVendorCategory() {
      try {
        const { data } = await axios({
          method: 'GET',
          url: `${api}/api/v1/m-ticket-category`,
        })

        this.kategoryList = data.data
      } catch (error) {
        // do nothing
      }
    },
    resetForm() {
      this.desc = ''
      this.nama_pengadaan = ''
      this.kategori_id = 1
      this.nama_vendor = ''
      this.pic_vendor = ''
      this.no_telepon = ''
      this.priority = 5
      this.bidang_usaha_id = 1
      this.type_pendaftaran_id = 1
      this.register_gems = false
      this.register_bce = false
      this.register_bkes = false
      this.assesment_k3l = false
      this.assesment_kplh = false
      this.note = null
      this.files = []
      this.email_vendor = ''
    },
    showModal() {
      const request = {
        desc: this.desc,
        nama_pengadaan: this.nama_pengadaan,
        kategori_id: this.kategori_id,
        nama_vendor: this.nama_vendor,
        pic_vendor: this.pic_vendor,
        no_telepon: this.no_telepon,
        priority: this.priority,
        bidang_usaha_id: this.bidang_usaha_id,
        type_pendaftaran_id: this.type_pendaftaran_id,
        register_ariba: this.register_ariba,
        register_gems: this.register_gems,
        register_bce: this.register_bce,
        register_bkes: this.register_bkes,
        assesment_k3l: this.assesment_k3l,
        assesment_kplh: this.assesment_kplh,
        note: this.note,
      }

      if (this.files && this.files.length > 0) {
        request['dokumen_legalitas'] = this.files[0]
      }

      if (
        this.desc &&
        this.desc != '' &&
        this.nama_pengadaan &&
        this.nama_pengadaan != '' &&
        this.nama_vendor &&
        this.nama_vendor != '' &&
        this.pic_vendor &&
        this.pic_vendor != '' &&
        this.email_vendor &&
        this.email_vendor != ''
      ) {
        this.$store.commit('modalStore/SET_MODAL_STATE', {
          name: 'dataRequest',
          value: request,
        })
        this.$store.commit('modalStore/SET_MODAL_STATE', {
          name: 'emailRequest',
          value: this.email_vendor,
        })
        this.$store.commit('modalStore/SHOW_NEW_VENDOR_EMAIL')
      } else {
        this.$store.commit('SET_NOTIF', 'Silahkan lengkapi data')
      }
    },
    submitRequest() {
      const self = this
      let url = `${api}/api/v1/request/vendor`

      const request = {
        desc: this.desc,
        nama_pengadaan: this.nama_pengadaan,
        kategori_id: this.kategori_id,
        nama_vendor: this.nama_vendor,
        pic_vendor: this.pic_vendor,
        no_telepon: this.no_telepon,
        priority: this.priority,
        bidang_usaha_id: this.bidang_usaha_id,
        type_pendaftaran_id: this.type_pendaftaran_id,
        register_gems: this.register_gems,
        register_bce: this.register_bce,
        register_bkes: this.register_bkes,
        assesment_k3l: this.assesment_k3l,
        assesment_kplh: this.assesment_kplh,
        note: this.note,
      }

      if (this.files && this.files.length > 0) {
        request['dokumen_legalitas'] = this.files[0]
      }

      if (
        request.desc &&
        request.desc != '' &&
        request.nama_pengadaan &&
        request.nama_pengadaan != '' &&
        request.nama_vendor &&
        request.nama_vendor != '' &&
        request.pic_vendor &&
        request.pic_vendor != '' &&
        this.email_vendor &&
        this.email_vendor != ''
      ) {
        this.$store.commit('modalStore/SET_GLOBAL_LOADING', true)

        let bodyFormData = new FormData()
        request.documen_legalitas &&
          bodyFormData.append('dokumen_legalitas', data.dokumen_legalitas)
        this.email_vendor &&
          this.email_vendor != '' &&
          bodyFormData.append('email_vendor', this.email_vendor)
        bodyFormData.append('desc', request.desc)
        bodyFormData.append('nama_pengadaan', request.nama_pengadaan)
        bodyFormData.append('kategori_id', request.kategori_id)
        bodyFormData.append('nama_vendor', request.nama_vendor)
        bodyFormData.append('pic_vendor', request.pic_vendor)
        bodyFormData.append('priority', request.priority)
        bodyFormData.append('bidang_usaha_id', request.bidang_usaha_id)
        bodyFormData.append('type_pendaftaran_id', request.type_pendaftaran_id)
        bodyFormData.append('register_gems', request.register_gems)
        bodyFormData.append('register_bce', request.register_bce)
        bodyFormData.append('register_bkes', request.register_bkes)
        bodyFormData.append('assesment_k3l', request.assesment_k3l)
        bodyFormData.append('assesment_kplh', request.assesment_kplh)
        bodyFormData.append('note', request.note)
        bodyFormData.append('user_id', self.$store.state.userid)
        bodyFormData.append('type', 1)

        axios({
          method: 'post',
          url,
          data: bodyFormData,
          headers: { 'Content-Type': 'multipart/form-data' },
        })
          .then(function (response) {
            self.$store.commit('modalStore/SET_GLOBAL_LOADING', false)
            self.resetForm()
            self.$store.commit('SET_NOTIF', 'Permintaan Anda sedang di Proses')
          })
          .catch(function (error) {
            self.$store.commit(
              'SET_NOTIF',
              self.$get(error, 'response.data.message', 'Error')
            )
            self.$store.commit('modalStore/SET_GLOBAL_LOADING', false)
          })
      } else {
        this.$store.commit('SET_NOTIF', 'Silahkan lengkapi data')
      }
    },
    closeModal() {
      this.$store.commit('modalStore/SET_REQ_NEW_VENDOR_MODAL', false)
    },
    fileChangeHandler(e) {
      this.files = Array.from(e.target.files)
    },
    downloadDoc() {
      const fileName = `JKT - ISUPPLIER\ISUPPLIER\Dokumen Isupplier\Dokumen Petunjuk.pdf`
      const fileLocation = `JKT%20-%20ISUPPLIER/ISUPPLIER/Dokumen%20Isupplier/Dokumen%20Petunjuk.pdf`
      if (fileLocation) {
        let linkUrl = `${api}/file/${fileLocation}`
        this.$store.commit('level1/SET_LOADING', true)
        axios({
          url: linkUrl,
          method: 'GET',
          responseType: 'blob',
        })
          .then(response => {
            let fileURL = window.URL.createObjectURL(new Blob([response.data]))
            let fileLink = document.createElement('a')

            fileLink.href = fileURL
            fileLink.setAttribute('download', this.$linkConverter(fileName))
            document.body.appendChild(fileLink)

            fileLink.click()

            this.$store.commit('level1/SET_LOADING', false)
          })
          .catch(error => {
            this.$store.commit('level1/SET_LOADING', false)
          })
      }
    },
    approve() {
      this.$store.dispatch('approvalSheet/approveVendor', {
        id: this.$route.params.id,
      })
    },
    approveHead() {
      this.$store.dispatch('approvalSheet/approveHead', {
        id: this.$route.params.id,
      })
    },
    reviewHead() {
      this.$store.dispatch('approvalSheet/reviewHead', {
        id: this.$route.params.id,
      })
    },
    reject() {
      this.$store.dispatch('approvalSheet/rejectVendor', {
        id: this.$route.params.id,
      })
    },
    reviseNow() {
      this.$router.push({
        path: `/approval/update-vendor/${this.$route.params.id}`,
      })
    },
    needReview() {
      this.$store.dispatch('approvalSheet/reviewVendor', {
        id: this.$route.params.id,
      })
    },
    postpone() {
      this.$store.dispatch('approvalSheet/postpone', {
        id: this.$route.params.id,
      })
    },
  },
}
</script>
